function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11,9.357l.875-.875a.22.22,0,0,1,.375.156v3.975a1.313,1.313,0,0,1-1.312,1.312H1.312A1.313,1.313,0,0,1,0,12.613V2.989A1.313,1.313,0,0,1,1.312,1.677H8.79a.22.22,0,0,1,.156.375l-.875.875a.217.217,0,0,1-.156.063h-6.6v9.624h9.624V9.51A.215.215,0,0,1,11,9.357ZM15.28,3.839,8.1,11.019l-2.472.273a1.129,1.129,0,0,1-1.247-1.247l.273-2.472L11.835.395a1.6,1.6,0,0,1,2.261,0l1.181,1.181a1.6,1.6,0,0,1,0,2.264Zm-2.7.845L10.991,3.1,5.911,8.178l-.2,1.785,1.785-.2Zm1.772-2.179L13.17,1.324a.285.285,0,0,0-.4,0l-.845.845,1.588,1.588.845-.845A.291.291,0,0,0,14.351,2.505Z",
  transform: "translate(0 0.075)"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.747,
    height: 14,
    viewBox: "0 0 15.747 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.0890db9c.svg";
export { ForwardRef as ReactComponent };